import React from "react";
import "./Home.css";
import API_CONFIG from "../config/api";

const Highlights = ({ title, highlights }) => {
  return (
    <section className="highlights-section">
      <div className="container">
        <h2 className="highlights-title">{title}</h2>
        <div className="highlights-grid">
          {highlights.map((highlight, index) => (
            <div className="highlight-card" key={index}>
              <div className="highlight-icon">
                <img src={`${API_CONFIG.IMAGES_URL}/${highlight.image}`} alt={highlight.title} />
              </div>
              <h3 className="highlight-title">{highlight.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Highlights;
